// Standard Google Tag Manager snippet, inlined so we don't depend on a wrapper
// library. Seeds the dataLayer with the gtm.js event and injects the async
// container script. Call once at startup, guarded by a configured GTM id.
export function initGtm(gtmId: string): void {
  const w = window as Window & { dataLayer?: Record<string, unknown>[] };

  w.dataLayer = w.dataLayer ?? [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;

  document.head.insertBefore(script, document.head.firstChild);
}
